import React, { useState, useEffect } from 'react';
import packageJson from '../../package.json';
import dayjs from 'dayjs';
// import isDev from './isDev';

const buildDateGreaterThan = (latestDate, currentDate) => {
  const latestDateTime = dayjs(latestDate);
  const currentDateTime = dayjs(currentDate);
  const updateIsNeeded = currentDateTime.diff(latestDateTime, 'second') > 0;

  // Proof that it works (only in development)
  // if (isDev()) console.log(`updateIsNeeded?: ${updateIsNeeded}`);

  return updateIsNeeded;
};

function withClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(null);

    useEffect(() => {
      fetch('/meta.json')
        .then((response) => response.json())
        .then((meta) => {
          // if "buildDate" field not exist in meta.json
          // use old Date to prevent conflicts with "react-clear-cache"
          const latestVersionDate = meta.buildDate || dayjs('2018-01-01');
          const currentVersionDate = packageJson.buildDate;

          const shouldForceRefresh = buildDateGreaterThan(
            latestVersionDate,
            currentVersionDate
          );

          if (shouldForceRefresh) {
            setIsLatestBuildDate(false);
            refreshCacheAndReload();
          } else {
            setIsLatestBuildDate(true);
          }
        });
    }, []);

    const refreshCacheAndReload = async () => {
      if ('caches' in window) {
        const names = await window.caches.keys();
        await Promise.all(names.map((name) => caches.delete(name)));
      }
      window.location.reload();
    };

    return (
      <React.Fragment>
        {isLatestBuildDate ? <Component {...props} /> : null}
      </React.Fragment>
    );
  }

  return ClearCacheComponent;
}

export default withClearCache;
